// src/pages/Contact.jsx - Complete and Corrected
import React from 'react';

const Services = () => {
  // Helper function for mailto links
  const createMailtoLink = (email, subject, body) => {
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);
    return `mailto:${email}?subject=${encodedSubject}&body=${encodedBody}`;
  };

  // Specific email handlers
  const handleArchitectureReview = () => {
    const subject = 'Architecture Review Booking';
    const body = `Hello Ayoub,

I would like to schedule an Architecture Review session.

Preferred dates/times:
- 

Brief project description:`;
    window.location.href = createMailtoLink('contact@a-ayoub.com', subject, body);
  };

  const handleCoachingInquiry = () => {
    const subject = 'Team Coaching Inquiry';
    const body = `Hello Ayoub,

We are interested in coaching services for our team.

Team size: 
Specific areas of focus: 
Preferred schedule: `;
    window.location.href = createMailtoLink('contact@a-ayoub.com', subject, body);
  };

  const handlePartnershipInquiry = () => {
    const subject = 'Technical Partnership Inquiry';
    const body = `Hello Ayoub,

I am interested in discussing a technical partnership.

Project overview: 
Desired engagement duration: 
Key challenges: `;
    window.location.href = createMailtoLink('contact@a-ayoub.com', subject, body);
  };

  const handleDiscoveryCall = () => {
    window.open('https://calendly.com/ayoub-abdelouahabi/meeting', '_blank');
  };

  const handleGeneralInquiry = () => {
    const subject = 'General Consultation Inquiry';
    const body = `Hello Ayoub,

I would like to discuss:`;
    window.location.href = createMailtoLink('contact@a-ayoub.com', subject, body);
  };

  const handleLinkedInClick = () => {
    window.open('https://linkedin.com/in/ayoub-abdelouahabi', '_blank');
  };

  const handleResumeDownload = () => {
    window.open('/resume.pdf', '_blank');
  };

  const handleQuickContact = () => {
    const subject = 'Quick Contact from Portfolio';
    const body = `Hello Ayoub,

I saw your portfolio and wanted to connect.`;
    window.location.href = createMailtoLink('contact@a-ayoub.com', subject, body);
  };

  return (
    <section className="full-section">
      <div className="contact-container">
        <div className="contact-header">
          <h1>Let's Build Something Together</h1>
          <p className="contact-subtitle">
            I collaborate with organizations on technical strategy, architecture design, 
            and solving complex engineering challenges
          </p>
        </div>
        
        <div className="contact-content">
          {/* Consultation Section - 4 CARDS IN ONE LINE */}
          <div className="consultation-section">
            <div className="consultation-header">
              <h2>Structured Services</h2>
              <p>Choose the engagement model that fits your needs</p>
            </div>
            
            <div className="consultation-grid four-columns">
              {/* Discovery Session Card */}
              <div className="consultation-card">
                <div className="consultation-badge">Most Popular</div>
                <div className="consultation-icon">🚀</div>
                <h3>Discovery Session</h3>
                <p className="consultation-price">Free</p>
                <ul className="consultation-features">
                  <li>30-minute video call</li>
                  <li>Technical challenge assessment</li>
                  <li>Initial architecture recommendations</li>
                  <li>Project feasibility discussion</li>
                </ul>
                <button 
                  className="consultation-cta"
                  onClick={handleDiscoveryCall}
                >
                  Book Discovery Call
                </button>
              </div>
              
              {/* Architecture Review Card */}
              <div className="consultation-card">
                <div className="consultation-badge">In-Depth</div>
                <div className="consultation-icon">🏗️</div>
                <h3>Architecture Review</h3>
                <p className="consultation-price">$250</p>
                <ul className="consultation-features">
                  <li>60-minute deep dive</li>
                  <li>System architecture analysis</li>
                  <li>Technology stack recommendations</li>
                  <li>Written summary & recommendations</li>
                </ul>
                <button 
                  className="consultation-cta secondary"
                  onClick={handleArchitectureReview}
                >
                  Email to Schedule
                </button>
              </div>
              
              {/* Coaching Card */}
              <div className="consultation-card coaching-card">
                <div className="consultation-badge">Team Development</div>
                <div className="consultation-icon">👥</div>
                <h3>Team Coaching</h3>
                <p className="consultation-price">Custom</p>
                <ul className="consultation-features">
                  <li>Architecture & design patterns training</li>
                  <li>Code review workshops</li>
                  <li>System design mentorship</li>
                  <li>Technical leadership development</li>
                </ul>
                <button 
                  className="consultation-cta coaching-cta"
                  onClick={handleCoachingInquiry}
                >
                  Discuss Team Needs
                </button>
              </div>
              
              {/* Technical Partnership Card */}
              <div className="consultation-card">
                <div className="consultation-badge">Ongoing</div>
                <div className="consultation-icon">🎯</div>
                <h3>Technical Partnership</h3>
                <p className="consultation-price">Custom</p>
                <ul className="consultation-features">
                  <li>Weekly/Monthly engagement</li>
                  <li>Architectural guidance & mentorship</li>
                  <li>Technical roadmap development</li>
                  <li>Project oversight & reviews</li>
                </ul>
                <button 
                  className="consultation-cta"
                  onClick={handlePartnershipInquiry}
                >
                  Discuss Partnership
                </button>
              </div>
            </div>
            
            <div className="consultation-notes">
              <div className="note-item">
                <div className="note-icon">⏱️</div>
                <div>
                  <h4>Flexible Scheduling</h4>
                  <p>Weekdays 9AM-6PM CET • Also available on select weekends</p>
                </div>
              </div>
              <div className="note-item">
                <div className="note-icon">💬</div>
                <div>
                  <h4>Preparation Recommended</h4>
                  <p>For best results, share context about your challenge before our call</p>
                </div>
              </div>
              <div className="note-item">
                <div className="note-icon">👥</div>
                <div>
                  <h4>Team Discounts Available</h4>
                  <p>Special rates for multiple team members or ongoing coaching engagements</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Coaching Details Section */}
          <div className="coaching-details">
            <h2>Team Coaching & Development</h2>
            <p className="coaching-subtitle">
              Elevate your engineering team's capabilities through structured coaching programs
            </p>
            
            <div className="coaching-benefits">
              <div className="benefit-card">
                <div className="benefit-icon">📚</div>
                <h3>Technical Workshops</h3>
                <p>Hands-on sessions on architecture patterns, cloud design, and system scalability</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">🔍</div>
                <h3>Code Review Sessions</h3>
                <p>Live code reviews focusing on architecture, design patterns, and best practices</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">🎯</div>
                <h3>Skill Development</h3>
                <p>Customized learning paths for senior engineers transitioning to architecture roles</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">📈</div>
                <h3>Team Growth</h3>
                <p>Building engineering excellence culture and improving team collaboration</p>
              </div>
            </div>
            
            <div className="coaching-approach">
              <h3>My Coaching Approach</h3>
              <div className="approach-steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <h4>Assessment</h4>
                  <p>Evaluate team's current skills, processes, and challenges</p>
                </div>
                <div className="step">
                  <div className="step-number">2</div>
                  <h4>Customization</h4>
                  <p>Design coaching program tailored to your team's specific needs</p>
                </div>
                <div className="step">
                  <div className="step-number">3</div>
                  <h4>Implementation</h4>
                  <p>Deliver workshops, mentorship, and ongoing guidance</p>
                </div>
                <div className="step">
                  <div className="step-number">4</div>
                  <h4>Evaluation</h4>
                  <p>Measure progress and adjust approach based on results</p>
                </div>
              </div>
            </div>
            
            <div className="coaching-cta-section">
              <h3>Ready to develop your team's capabilities?</h3>
              <p>
                Let's discuss how coaching can help your engineers grow, improve system design skills, 
                and deliver higher quality software.
              </p>
              <button 
                className="btn-primary coaching-inquiry-btn"
                onClick={handleCoachingInquiry}
              >
                Schedule Team Assessment
              </button>
            </div>
          </div>
          
          {/* FAQ Section */}
          <div className="faq-section">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-grid">
              <div className="faq-item">
                <h3>What happens during a discovery call?</h3>
                <p>
                  We'll discuss your current technical challenges, your goals, and explore 
                  potential solutions. You'll get immediate feedback and we'll determine if 
                  there's a good fit for further collaboration.
                </p>
              </div>
              <div className="faq-item">
                <h3>How quickly can we start working together?</h3>
                <p>
                  Discovery calls can typically be scheduled within 1-3 days. For ongoing 
                  partnerships, we can usually start within a week of initial discussion.
                </p>
              </div>
              <div className="faq-item">
                <h3>What types of projects do you work on?</h3>
                <p>
                  I specialize in cloud architecture, data systems, SaaS platforms, and 
                  technical strategy. This includes cloud migrations, system redesigns, 
                  data pipeline architecture, and team capability building.
                </p>
              </div>
              <div className="faq-item">
                <h3>Do you offer team coaching packages?</h3>
                <p>
                  Yes, I offer customized coaching packages for engineering teams. These include 
                  workshops, code reviews, architecture training, and ongoing mentorship. 
                  Contact me to discuss your team's specific needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;